import { render, staticRenderFns } from "./AdditionalReportingCurrencies.vue?vue&type=template&id=27322bad&scoped=true"
import script from "./AdditionalReportingCurrencies.vue?vue&type=script&lang=ts"
export * from "./AdditionalReportingCurrencies.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalReportingCurrencies.vue?vue&type=style&index=0&id=27322bad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27322bad",
  null
  
)

export default component.exports